<div *ngIf="isLoading | async" class="loader-overlay">
    <div class="loader"></div>
</div>